export const DEFAULT_ERRORS = [
  {
    error: 'unknownException',
    description:
      'An exception occurred it is not possible to identify deeper details',
  },
  {
    error: 'unexpectedException',
    description:
      'An exception occurred and an object of type Error was received',
  },
  {
    error: 'unhandledOperationError',
    description:
      'A possible operation error was not handled because it was not found in the error catalog',
  },
] as const;

export type DefaultError = typeof DEFAULT_ERRORS[number]['error'];
